import styled from 'styled-components';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import colors from '../../../../styles/colors';

const TransitionList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const TransitionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 10px 0;
  font-size: 14px;

  &:not(:first-child) {
    border-top: 1px solid ${colors.shades.gamma4};
  }
`;

const TransitionState = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${colors.shades.gamma7};
`;

const PoolLabel = styled.span`
  font-weight: 600;
  color: ${colors.base.secondary2};
`;

const TransitionIcon = styled(ArrowForwardIcon)`
  && {
    font-size: 16px;
  }
`;

export {
  TransitionList,
  TransitionRow,
  TransitionState,
  PoolLabel,
  TransitionIcon,
};
